import "./style.css";
import "./ProjectApproval.css";
import axios from "axios";
import React, { useEffect, useState } from "react";
import Header from './Header';
import { useParams, useNavigate } from 'react-router-dom';
import { fmtDateTimeSecVN } from './timeZone';
// Same origin, like every other screen: nginx proxies /api and /auth to the backend on both
// ports, and an absolute http:// URL is blocked as mixed content the moment the site answers
// on https (2026-09-02). See backendConfig.js.
import { BACKEND_URL } from './backendConfig';
import { useTranslation } from 'react-i18next';
import useAuth from './useAuth';

// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://13.67.118.92:5000";


function Profile() {
    const { t } = useTranslation();
    const { roleNames = {} } = useAuth();
    const [user, setUser] = useState(null);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const { userId } = useParams();
    const navigate = useNavigate();
  
    useEffect(() => {
      const fetchUser = async () => {
        setLoading(true);
        try {
          const response = await axios.get(`${BACKEND_URL}/user/${userId}`, { withCredentials: true });
          setUser(response.data);
          setError("");
        } catch (err) {
          console.error("Error fetching user data:", err);
          setError(t('xUsers.err.fetchFailed'));
        } finally {
          setLoading(false);
        }
      };
  
      fetchUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId]
  );
  
    const handleResetPassword = async () => {
      if (!user) return;
  
      setLoading(true);
      setMessage("");
      setError("");

      try {
        const response = await axios.post(`${BACKEND_URL}/reset-password/request`, { username: user.UserName });
        setMessage(response.data.message);
      } catch (err) {
        setError(err.response?.data?.error || t('xUsers.err.generic'));
      } finally {
        setLoading(false);
      }
    };
  
    /* THE PORTAL'S OWN PAGE (Max, 2026-10-27: "cái view này cũng đang khác format với những view khác"): the frame,
       title, banners and buttons of Project Approval and the other screens, instead of the old centred form card with
       black rounded buttons. Loading and errors are drawn inside the same frame, under the header. */
    const fields = user ? [
      [t('xUsers.f.id'), user.UserId],
      [t('xUsers.f.username'), user.UserName],
      [t('xUsers.f.firstNameCap'), user.UserFirstname],
      [t('xUsers.f.lastNameCap'), user.UserLastname],
      [t('xUsers.f.email'), user.UserEmail],
      // the role's name, not its key (Jay 02/11: "SOP Team" is "S.OP Staff")
      [t('xUsers.f.role'), roleNames[user.UserRole] || user.UserRole],
      [t('xUsers.f.isActive'), user.IsActive ? t('xUsers.profile.yes') : t('xUsers.profile.no')],
      [t('xUsers.f.createdAt'), fmtDateTimeSecVN(user.UserCreatedAt)],
    ] : [];

    return (
      <div className="pa-page">
        <Header />
        <main className="pa-main up-page">
          <div className="pa-title">
            <h2>{t('xUsers.profile.title')}</h2>
            {user && <p>{[user.UserFirstname, user.UserLastname].filter(Boolean).join(' ') || user.UserName} · {user.UserEmail}</p>}
          </div>

          {error && <div className="pa-banner err">{error}</div>}
          {message && <div className="pa-banner ok">{message}</div>}
          {loading && !user && <p className="up-muted">{t('xUsers.profile.loading')}</p>}
          {!loading && !error && !user && <p className="up-muted">{t('xUsers.profile.noData')}</p>}

          {user && (
            <section className="up-card" data-up-card>
              <dl className="up-fields">
                {fields.map(([label, value]) => (
                  <div className="up-row" key={label}>
                    <dt>{label}</dt>
                    <dd>{value === null || value === undefined || value === '' ? '—' : value}</dd>
                  </div>
                ))}
              </dl>
              <div className="up-actions">
                <button type="button" className="pa-btn" onClick={() => navigate(-1)} data-up-back>{t('xUsers.profile.back')}</button>
                <button type="button" className="pa-btn primary" onClick={handleResetPassword} disabled={loading} data-up-reset>
                  {loading ? t('xUsers.profile.sending') : t('xUsers.profile.sendReset')}
                </button>
              </div>
            </section>
          )}

          <style jsx="true">{`
            .up-card { max-width: 760px; background: var(--portal-surface, #fff); border: 1px solid var(--portal-border, #e2e8f0);
              border-radius: 10px; overflow: hidden; }
            .up-fields { margin: 0; }
            .up-row { display: grid; grid-template-columns: 200px 1fr; border-bottom: 1px solid var(--portal-border, #eef2f7); }
            .up-row dt { margin: 0; padding: 11px 16px; font-size: 13px; font-weight: 600; color: var(--portal-text-muted, #64748b);
              background: var(--portal-surface-muted, #f8fafc); }
            .up-row dd { margin: 0; padding: 11px 16px; font-size: 14px; color: var(--portal-text, #1f2937); word-break: break-word; }
            .up-actions { display: flex; gap: 10px; justify-content: flex-end; padding: 14px 16px; }
            .up-actions .pa-btn { font-size: 13.5px; padding: 7px 16px; }
            .up-muted { color: var(--portal-text-muted, #64748b); font-size: 13.5px; }
            @media (max-width: 640px) { .up-row { grid-template-columns: 1fr; } .up-row dt { padding-bottom: 2px; } }
          `}</style>
        </main>
      </div>
      );
    }
    
    export default Profile;